// extracted by mini-css-extract-plugin
export default {"departments":"FL-z","departmentHeading":"GL-z","departmentSection":"HL-z","departmentName":"IL-z","departmentLink":"JL-z","expandIcon":"KL-z"};